export const getPoolRequestInboxCount = state => state.processStatement.poolRequestInboxCount;